import styled from 'styled-components';
import React, { FC, ReactNode } from 'react';
import { rhythm } from '../../utils/typography';
import { floralwhite, media } from '../../utils/styles';
import { Section } from './index';

const HeroContainer = styled.div`
  display: flex;
  margin: ${rhythm(1.5)} 0;
  ${media.mobile`flex-direction: column;`}
`;
const HeroImage = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ${media.mobile`
  padding-bottom: ${rhythm(1)}
  `}
`;
const HeroSpacer = styled.div`
  width: ${rhythm(2.5)};
  ${media.mobile`
    display: none;
  `}
`;
const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

type PageHeroProps = {
  image: ReactNode;
  content: ReactNode;
};

export const PageHero: FC<PageHeroProps> = ({ image, content }) => (
  <Section color={floralwhite}>
    <HeroContainer>
      <HeroImage>{image}</HeroImage>
      <HeroSpacer />
      <HeroContent>{content}</HeroContent>
    </HeroContainer>
  </Section>
);
